export enum ReturnCodeOrderFields {
  RESTAURANT_ID = 'restaurantId',
  RESTAURANT_NAME = 'restaurantName',
  RETURN_CODE_NAME = 'name',
  RETURN_CODE_STATUS = 'status',
  RETURN_CODE_CREATION_DATE = 'recordCreatedAt',
}
